import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const testimonialBlocks = document.querySelectorAll('.testimonials');

  if (0 < testimonialBlocks.length) {
    testimonialBlocks.forEach((testimonialBlock) => {
      const carousel = testimonialBlock.querySelector(
        '.testimonials__carousel.swiper'
      );
      if (!carousel) {
        return;
      }

      new Swiper(carousel, {
        slidesPerView: 1.6,
        spaceBetween: 30,
        //loop: true,

        navigation: {
          prevEl: testimonialBlock.querySelector('.swiper-button-prev'),
          nextEl: testimonialBlock.querySelector('.swiper-button-next'),
        },
      });
    });
  }
});
